import { ErrorButton, ErrorMessage } from '@toggle/design-system';
import { mailTo } from '@toggle/helpers';
import React, { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { config } from '~/config';

import * as S from './ErrorMessageWrapper.styles';

type Variant = 'error' | 'empty';

interface ErrorMessageWrapperProps {
  variant?: Variant;
  displayIcon?: boolean;
  onClick?: () => void;
  title?: string;
  subTitle?: string;
  showBorder?: boolean;
}

type MessageState = {
  icon: Variant;
  title: string;
  getSubtitle: () => ReactNode;
  buttonProps?: ErrorButton;
};

export const ErrorMessageWrapper = ({
  onClick,
  displayIcon,
  variant = 'error',
  title,
  subTitle,
  showBorder = true,
  ...rest
}: ErrorMessageWrapperProps) => {
  const { t } = useTranslation('widget');
  const supportEmail = mailTo(config.supportEmail);
  const errorButton = {
    label: t('error.reloadButtonLabel'),
    onClick,
  };

  const messageStates: Record<Variant, MessageState> = {
    error: {
      icon: 'error',
      title: t('widget:error.titleError'),
      getSubtitle: () => (
        <Trans
          t={t}
          i18nKey={'widget:error.subtitleError'}
          components={[<S.Link key="key-1" href={supportEmail} />]}
          values={{
            email: config.supportEmail,
          }}
        />
      ),
      buttonProps: errorButton,
    },
    empty: {
      icon: 'empty',
      title: t('widget:empty.titleEmpty'),
      getSubtitle: () => t('widget:empty.subtitleEmpty'),
    },
  };

  return (
    <S.StyledErrorMessageRoot {...rest} $showBorder={showBorder}>
      <ErrorMessage
        {...(!!displayIcon && { displayIcon: messageStates[variant].icon })}
        title={title ?? messageStates[variant].title}
        subtitle={subTitle ?? messageStates[variant].getSubtitle()}
        buttonProps={messageStates[variant]?.buttonProps}
      />
    </S.StyledErrorMessageRoot>
  );
};
